export const WS_ENDPOINT = 'wss://appservices-ws-dev.trustscience.com/clientconsole';
export const IMAGE_URL = 'https://d3p56cllgt1gum.cloudfront.net';
export const COGNITO_DOMAIN = 'clientconsole-dev.auth.us-west-2.amazoncognito.com';
export const DOCS_URL = 'https://appservices-dev.trustscience.com/docs';
export const S3_BUCKET = 'application-services-static-websites';
export const ENVIRONMENT = 'dev';
export const LOGROCKET_APPID = false;
export const FLOWBUILDER_URL = 'https://web2.flowbuilder.trustscience.com';
export const FLOWBUILDER_API_URL = 'https://z157au2l5h.execute-api.us-west-2.amazonaws.com';
export const LOGOUT_URL = false;
export const CURRENT_ENVIRONMENT_NAME = 'Dev';
export const UAT_ENVIRONMENT_NAME = 'Fake UAT';
export const USE_CHATBOT_LOCAL_FETCH_STRATEGY = false;
